export default "{\n    \"confirmButtonLabel\": \"Confirmer\",\n    \"cancelButtonLabel\": \"Annuler\"\n}\n"